// Robust download helper for binary responses (PDF/PNG/etc).
// - Uses the shared axios `api` instance so cookies + headers stay consistent
//   with the rest of the app (works on Safari & mobile where bare fetch is flaky).
// - Long timeout because AI doc generation with images can take 1-2 min.
// - Appends the <a> tag to body before clicking (Safari requirement) and revokes
//   the blob URL afterwards to free memory.

import { api } from '@/lib/api';

export async function downloadBlob({ path, method = 'POST', data, params, filename, timeout = 180000, formData = false }) {
  const config = {
    url: path,
    method,
    responseType: 'blob',
    timeout,
    params,
  };
  if (formData) {
    config.data = data; // axios sets multipart boundary automatically
  } else if (data !== undefined) {
    config.data = data;
    config.headers = { 'Content-Type': 'application/json' };
  }
  let res;
  try {
    res = await api.request(config);
  } catch (err) {
    // The server returned an error — try to read it as JSON for a helpful message
    let detail = '';
    try {
      if (err.response?.data) {
        const text = await err.response.data.text?.();
        if (text) detail = (() => { try { return JSON.parse(text).detail; } catch (_e) { return text; } })();
      }
    } catch (_e) { /* ignore */ }
    const msg = detail || err.response?.statusText || err.message || 'download_failed';
    throw new Error(msg);
  }
  const blob = res.data instanceof Blob ? res.data : new Blob([res.data]);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'indivalife_download';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  // Cleanup: give Safari a tick before revoking
  setTimeout(() => {
    try { document.body.removeChild(a); URL.revokeObjectURL(url); } catch (_e) { /* ignore */ }
  }, 200);
  return blob;
}
